import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './router'
import '@/assets/styles/variables.scss'
import { MotionPlugin } from '@vueuse/motion'
import WebFont from 'webfontloader'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(MotionPlugin)

WebFont.load({
  custom: {
    families: ['OPPO Sans'],
    urls: ['/fonts/OPPOSans3.0-Regular.woff2', '/fonts/OPPOSans3.0-Medium.woff2']
  }
})

app.mount('#app')